import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";
import { adaptEvents } from "../adapters/adaptEvents";

interface FetchParams {
	page: number;
	pageSize: number;
	published?: boolean;
	search?: string;
	audienceGroupId?: number;
	onlyUnrestricted?: boolean;
}

const fetchEventsPaged = async ({
	page,
	pageSize,
	published,
	search,
	audienceGroupId,
	onlyUnrestricted
}: FetchParams) => {
	const response = await cmsClient.get<CMSPaginatedData<IEvent>>(
		"/homepage/admin/events/",
		{
			params: {
				page,
				page_size: pageSize,
				published,
				search: search || undefined,
				audience_group_id: audienceGroupId,
				only_unrestricted: onlyUnrestricted ? true : undefined
			}
		}
	);

	return response.data;
};

const useEventsPaged = (
	page: number,
	pageSize: number,
	published?: boolean,
	search?: string,
	audienceGroupId?: number,
	onlyUnrestricted?: boolean
) => {
	return useQuery(
		[
			"events",
			{ page, pageSize, published, search, audienceGroupId, onlyUnrestricted }
		],
		() =>
			fetchEventsPaged({
				page,
				pageSize,
				published,
				search,
				audienceGroupId,
				onlyUnrestricted
			}),
		{
			keepPreviousData: true,
			select: (data) => ({
				...data,
				results: adaptEvents(data.results)
			})
		}
	);
};

export default useEventsPaged;
